import React, { useEffect, useState } from "react";
import { Row, Col, Button, FormGroup, FormLabel, FormCheck, FormText, FormControl, Spinner } from "react-bootstrap";
import Select from "react-select";
import CreatableSelect from 'react-select/creatable';
import { Field, Form } from "formik";
import * as apiRegion from '../../apis/region';
import { isFileImage } from "../../utils/CheckFileType";
import { fileToBase64 } from "../../utils/FileToBase64";
import styles from './RegistrationPage.module.css';

const RegistrationForm = (props) => {
    const { values, touched, setFieldValue, setFieldTouched, setFieldError, errors, handleChange, categories, isSubmitting } = props;

    const [selectedCategories, setSelectedCategories] = useState();
    const [selectedProvince, setSelectedProvince] = useState("");
    const [selectedCity, setSelectedCity] = useState("");
    const [selectedDistrict, setSelectedDistrict] = useState("");
    const [selectedZipcode, setSelectedZipcode] = useState("");

    const [isDisabledCity, setIsDisabledCity] = useState(true);
    const [isDisabledDistrict, setIsDisabledDistrict] = useState(true);
    const [isDisabledZipcode, setIsDisabledZipcode] = useState(true);
  
    const [provinces, setProvinces] = useState([]);
    const [cities, setCities] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [zipcodes, setZipcodes] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const provincesPromise = apiRegion.getProvinces();
            const [provincesResponse] = await Promise.all([
                provincesPromise,
            ]);
            setProvinces(provincesResponse.data.result);
        }
        fetchData().catch(console.error);
    }, [])
    
    const getCategoryMapping = () => {
        return categories.map(c => ({ value: c.id, label: c.name.split("-")[1] }));
    }

    const getRegionMapping = (region) => {
        if (region) {
            return region.map(z => ({ value: z.id, label: z.text }));
        }
    }

    const handleSelectProvince = async ( setFieldValue, e ) => {
        if (e === null) {
            setSelectedProvince("");
            setSelectedCity("");
            setSelectedDistrict("");
            setSelectedZipcode("");
            setIsDisabledCity(true);
            setIsDisabledDistrict(true);
            setIsDisabledZipcode(true);
            return;
        }
        setSelectedProvince(e);
        setFieldValue('province', e.label);

        const res = await apiRegion.getCities({provinceId: e.value});
        if (res.data) {
            setCities(res.data.result);
            setIsDisabledCity(false);
            getRegionMapping(cities);
        }
    }
    
    const handleSelectCity = async ( setFieldValue, e ) => {
        if (e === null) {
            setSelectedCity("");
            setSelectedDistrict("");
            setSelectedZipcode("");
            setIsDisabledDistrict(true);
            setIsDisabledZipcode(true);
            return;
        }
        setSelectedCity(e);
        setFieldValue('city', e.label);

        const res = await apiRegion.getDistricts({cityId: e.value});
        if (res.data) {
            setDistricts(res.data.result);
            setIsDisabledDistrict(false);
            getRegionMapping(districts);
        }
    }

    const handleSelectDistrict = async ( setFieldValue, e ) => {
        if (e === null) {
            setSelectedDistrict("");
            setSelectedZipcode("");
            setIsDisabledZipcode(true);
            return;
        }
        setSelectedDistrict(e);
        setFieldValue('district', e.label);

        const res = await apiRegion.getZipcodes({cityId: selectedCity.value, districtId: e.value});
        if (res.data) {
            setZipcodes(res.data.result);
            setIsDisabledZipcode(false);
            getRegionMapping(zipcodes);
        }
    }

    const handleSelectZipcode = async ( setFieldValue, e ) => {
        if (e === null) {
            setSelectedZipcode("");
            await setFieldValue('zipcode', "");
            await setFieldTouched('zipcode', true);
            return;
        }
        setSelectedZipcode(e);
        await setFieldValue('zipcode', e.label);
        await setFieldTouched('zipcode', true);
    }

    const handleKtpChange = async ( setFieldValue, e ) => {
        const file = e.currentTarget.files[0];
        if (!file){
            setFieldValue('ktpFile', null);
            setFieldValue('ktpFileType', null);
            setFieldError('ktpFile', 'File KTP harus terisii');
            return;
        }

        if (!isFileImage(file)) {
            e.target.value = null;
            alert("File harus berupa gambar JPG/JPEG/PNG!");
            return;
        }

        const MAX_FILE_SIZE = 2 * 1000000

        if (file.size > MAX_FILE_SIZE) {
            e.target.value = null;
            alert("Ukuran maksimum untuk KTP adalah 2 MB");
            return;
        }

        try {
            const base64 = await fileToBase64(file);
            setFieldValue('ktpFile', base64);
            setFieldValue('ktpFileType', file.type);
            return;
        } catch (error) {
            console.error(error);
            return;
        }
    }

    const handlePricelist = async ( setFieldValue, e, pricelistPointer ) => {
        const file = e.currentTarget.files[0];
        if (!file){
            setFieldValue(pricelistPointer, null);
            return;
        }

        const MAX_FILE_SIZE = 10 * 1000000
        if (file.size > MAX_FILE_SIZE) {
            e.target.value = null;
            alert("Ukuran maksimum untuk pricelist adalah 10 MB");
            return;
        }

        setFieldValue(pricelistPointer, file);
    }

    const prepareCategoriesData = (categories) => {
        if (!categories) {
            throw new Error('Kategori tidak boleh kosong!');
        }

        return Object.entries(categories).map(([, value]) => {
            return {
                id: value.value,
                name: value.label
            }
        });
    }

    const handleSelectCategories = async ( setFieldValue, e ) => {
        if (e === null) {
            setSelectedCategories({});
            return;
        }
        setSelectedCategories(e);
        const categories = prepareCategoriesData(e);
        setFieldValue('productTags', categories);
    }

    const isFormValid = () => {
        const isErrorsEmpty = Object.keys(errors).length === 0;
        return !isSubmitting && isErrorsEmpty && values.registrarName && values.email && values.whatsapp && values.productTags && 
        values.businessType && values.businessName && values.province && values.city && values.district &&
        values.zipcode && values.address && values.ktpFile && (values.pricelist1 || values.pricelist2 || values.pricelist3);
    }
    
    return <Form>
        <div className="my-4">
            <Row className="mb-3">
                <FormGroup>
                    <FormLabel className={styles.fwMedium}>Nama Pendaftar</FormLabel>
                    <Field name="registrarName"
                    placeholder="Masukkan nama sesuai KTP pendaftar"
                    className={
                        'form-control' +
                        (errors.registrarName && touched.registrarName ? ' is-invalid' : '')
                    }
                    onChange={handleChange} />
                    <FormControl.Feedback type="invalid">
                        {errors.registrarName}
                    </FormControl.Feedback>
                </FormGroup>
            </Row>
            <Row className="mb-3">
                <FormGroup>
                    <FormLabel className={styles.fwMedium}>Email</FormLabel>
                    <Field name="email"
                    placeholder="Contoh: suppliersegari@email.com"
                    className={
                        'form-control' +
                        (errors.email && touched.email ? ' is-invalid' : '')
                    }
                    onChange={handleChange} />
                    <FormControl.Feedback type="invalid">
                        {errors.email}
                    </FormControl.Feedback>
                </FormGroup>
            </Row>
            <Row className="mb-3">
                <FormGroup>
                    <FormLabel className={styles.fwMedium}>Nomor Whatsapp</FormLabel>
                    <Field type="text" name="whatsapp"
                    placeholder="Contoh: 081234567890" 
                    className={
                        'form-control' +
                        (errors.whatsapp && touched.whatsapp ? ' is-invalid' : '')
                    }
                    onChange={handleChange} />
                    <FormControl.Feedback type="invalid">
                        {errors.whatsapp}
                    </FormControl.Feedback>
                </FormGroup>
            </Row>
            <hr className="my-4" />
            <Row className="mb-3">
                <FormGroup>
                    <FormLabel className={styles.fwMedium}>Jenis Produk yang Dijual</FormLabel>
                    <Select
                        isMulti isClearable={true} required
                        name="productTags"
                        value={selectedCategories}
                        placeholder={"Pilih jenis produk yang dijual"}
                        className={
                            (errors.productTags && touched.productTags ? ' is-invalid' : '')
                        }
                        options={getCategoryMapping()}
                        onChange={(e) => {handleSelectCategories(setFieldValue, e)}}
                    />
                    <FormControl.Feedback type="invalid">
                        {errors.productTags}
                    </FormControl.Feedback>
                </FormGroup>
            </Row>
            <Row className="mb-3">
                <FormLabel className={styles.fwMedium}>Jenis Usaha</FormLabel>
                <FormGroup>
                    <FormCheck
                        inline required
                        type="radio"
                        name="businessType"
                        id="type-perseorangan"
                        label="Perseorangan"
                        onChange={(e) => {setFieldValue('businessType', 'Perseorangan')}}
                    />
                    <FormCheck
                        inline required
                        type="radio"
                        name="businessType"
                        id="type-perusahaan"
                        label="Perusahaan"
                        onChange={(e) => {setFieldValue('businessType', 'Perusahaan')}}
                    />
                </FormGroup>
            </Row>
            <Row className="mb-3">
                <FormGroup>
                    <FormLabel className={styles.fwMedium}>Nama Pemilik/Perusahaan</FormLabel>
                    <Field name="businessName" 
                    placeholder="Isi nama pemilik jika perseorangan; isi nama perusahaan jika perusahaan"
                    className={
                        'form-control' +
                        (errors.businessName && touched.businessName ? ' is-invalid' : '')
                    } />
                    <FormControl.Feedback type="invalid">
                        {errors.businessName}
                    </FormControl.Feedback>
                </FormGroup>
            </Row>
            <Row className="mb-2">
                <FormLabel className={[styles.fwMedium, "my-0"]}>Alamat</FormLabel>
                <FormText className="mb-2">Silakan ketik apabila tidak menemukan data di pilihan</FormText>
                <FormGroup as={Col}>
                    <Select
                        isClearable required
                        name="province"
                        value={selectedProvince}
                        placeholder={"Pilih provinsi"}
                        options={getRegionMapping(provinces)}
                        onChange={(e) => {handleSelectProvince(setFieldValue, e)}}
                    />
                </FormGroup>
                <FormGroup as={Col}>
                    <Select
                        isClearable required
                        isDisabled={isDisabledCity}
                        name="city"
                        value={selectedCity}
                        placeholder={"Pilih kota/kabupaten"}
                        options={getRegionMapping(cities)}
                        onChange={(e) => {handleSelectCity(setFieldValue, e)}}
                    />
                </FormGroup>
            </Row>
            <Row className="mb-2">
                <FormGroup as={Col}>
                    <Select
                        isClearable required
                        isDisabled={isDisabledDistrict}
                        name="district"
                        value={selectedDistrict}
                        placeholder={"Pilih kecamatan"}
                        options={getRegionMapping(districts)}
                        onChange={(e) => {handleSelectDistrict(setFieldValue, e)}}
                    />
                </FormGroup>
                <FormGroup as={Col}>
                    <CreatableSelect
                        formatCreateLabel={(input) => `Pilih kode pos '${input}'`}
                        className={(errors.zipcode && touched.zipcode ? styles.invalidField : '')}
                        isClearable required
                        isDisabled={isDisabledZipcode}
                        name="zipcode"
                        value={selectedZipcode}
                        placeholder={"Pilih kode pos"}
                        options={getRegionMapping(zipcodes)}
                        onChange={(e) => {handleSelectZipcode(setFieldValue, e)}}
                    />
                    {errors.zipcode && touched.zipcode &&
                    <p className={styles.errorMessage}>
                        <small>{errors.zipcode}</small>
                    </p>
                    }
                    
                </FormGroup>
            </Row>
            <Row className="mb-3">
                <FormGroup>
                    <Field as="textarea" name="address"
                    placeholder="Masukkan detail alamat. Contoh: Jalan Bojong Raya No. 37 RT.1/RW.1, Rw. Buaya"
                    className={
                        'form-control' +
                        (errors.address && touched.address ? ' is-invalid' : '')
                    }/>
                    <FormControl.Feedback type="invalid">
                        {errors.address}
                    </FormControl.Feedback>
                </FormGroup>
            </Row>
            <Row className="mb-3">
                <FormGroup>
                    <FormLabel className={styles.fwMedium}>Upload Foto KTP</FormLabel>
                    <input 
                        type="file"
                        accept="image/jpeg,image/png" name="ktpFile"
                        onChange={(e) => {
                            handleKtpChange( setFieldValue, e );
                        }}
                        className={
                            'form-control' +
                            (errors.ktpFile && touched.ktpFile ? ' is-invalid' : '')
                        }
                    />
                    <FormControl.Feedback type="invalid">
                        {errors.ktpFile}
                    </FormControl.Feedback>
                    <FormText>Format file harus JPG, JPEG, PNG dengan ukuran maks. 2 MB</FormText>
                </FormGroup>
            </Row>
            <Row className="mb-3">
                <FormGroup>
                    <FormLabel className={styles.fwMedium}>Upload Daftar Harga (Pricelist)</FormLabel>
                    <input 
                        className={"form-control"} type="file"
                        accept="image/jpeg,image/png,application/pdf,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" name="pricelist1"
                        onChange={(e) =>
                            handlePricelist( setFieldValue, e, "pricelist1")
                        }
                    />
                    <input 
                        className={"form-control"} type="file"
                        accept="image/jpeg,image/png,application/pdf,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" name="pricelist2"
                        onChange={(e) =>
                            handlePricelist( setFieldValue, e, "pricelist2")
                        }
                    />
                    <input 
                        className={"form-control"} type="file"
                        accept="image/jpeg,image/png,application/pdf,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" name="pricelist3"
                        onChange={(e) =>
                            handlePricelist( setFieldValue, e, "pricelist3")
                        }
                    />
                    <FormControl.Feedback type="invalid">
                        {errors.pricelist1 || errors.pricelist2 || errors.pricelist3}
                    </FormControl.Feedback>
                    <FormText>Upload daftar harga dalam bentuk gambar, PDF, atau Excel dengan ukuran maks. 10 MB</FormText>
                </FormGroup>
            </Row>
        </div>
        <Row>
            <Col>
                <Button className={styles.btnRegistration} type='submit' disabled={!isFormValid()}>
                    {isSubmitting && <Spinner animation="border" variant="light" size="sm"/>} Daftar
                </Button>
            </Col>
        </Row>
    </Form>
}

export default RegistrationForm;